const DirectionRight = ({ className, width = '14', height = '14' }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="2" fill="#F9F9F9" />
    <path
      d="M15.6169 13.3333H14.0003C14.0003 13.3333 12.667 13.3333 12.667 14.7999C12.667 15.3333 12.667 15.9999 12.667 15.9999"
      stroke="#3C3C3B"
      strokeWidth="0.8"
      strokeLinecap="square"
    />
    <path
      d="M14.667 14.6667L16.0003 13.3333L14.667 12"
      stroke="#3C3C3B"
      strokeWidth="0.8"
      strokeLinecap="square"
    />
    <path
      d="M7.3333 14L14 7.33325L20.6667 14L14 20.6667L7.3333 14Z"
      stroke="#3C3C3B"
      strokeWidth="0.8"
      strokeLinecap="square"
    />
  </svg>
);

export default DirectionRight;
